import { Component, Inject, Injectable, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ChangeDetectorRef, NgZone, ViewChild } from '@angular/core';

import { RouterLink } from '@angular/router/src/directives/router_link';
import { element } from 'protractor';
import { filter } from 'rxjs/operator/filter';
import { FilterJsonData } from '../Pipes/FilterPipe';
import { DefaultTS } from '../SharedComponents/Default';
import { SortJsonData } from '../Pipes/SortingPipe';
import { debounce } from 'rxjs/operator/debounce';
import { FileUploaderCustom } from '../SharedComponents/FileUploader';


@Injectable()
@Component({
  selector: 'Messaging',
  templateUrl: './Messaging.html',
  styleUrls: ['./Messaging.css']
})

export class Messaging implements OnInit  {
  public http: HttpClient;
  public baseUrl: string;
  public AddAttachmentMode = false;
  public InputFields = {} as any;
  public Message = [] as any;
  public Attachment = [] as any;
  
  public UserArrayFromDb = [];//{ 'Name': 'Zain', 'Email': 'zain@gmail.com' }, { 'Name': 'Umer', 'Email': 'Umer @gmail.com' },    { 'Name': 'Aneeq', 'Email': 'aneeq@gmail.com' }
  public UserArrayTagged = [] as any;

  @ViewChild('fileinputAttachment') fileinputAttachment;
  @Input() public OtherEntityID = 0;
  @Input() public MessageTypeID = 0;
  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private Default: DefaultTS, private FileUpload: FileUploaderCustom) {
    this.http = http;
    this.baseUrl = baseUrl;
    this.Default.CheckIsUserLoggedIn();
    this.GetUserNameEmailAndID();
  }

  ngOnInit() {
    this.AjaxLoadMessages();
  }
  public AjaxLoadMessages() {
    let PostData = {} as any;
    PostData.OtherEntityID = this.OtherEntityID;
    PostData.MessageTypeID = this.MessageTypeID;
    this.Message = [];
    this.Attachment = [];
    this.Default.SetMasterAnimation(true);
    this.http.post(this.baseUrl + 'api/Message/AjaxLoadMessages', PostData).subscribe(result => {
      var l_arrResponse = result as any;
      this.Default.SetMasterAnimation(false);
      if (l_arrResponse[0][0].Status == 1) {
        this.Message = l_arrResponse[1];
        this.Attachment = l_arrResponse[2];
      }
      else {

      }
    }, error => console.error(error));
  }

  public SaveMessage() {
    let PostData = {} as any;
    PostData.Content = '';
    PostData.FileURLs = '';
    PostData.OtherEntityID = this.OtherEntityID;
    PostData.MessageTypeID = this.MessageTypeID;
    var l_boolIsOkay = true;
    var l_strMessage = "Following are required fields: ";
    for (let field in PostData) {
      if (this.InputFields[field] !== undefined && this.InputFields[field] != null)
        PostData[field] = this.InputFields[field];
    }

    if (this.fileinputAttachment) {
      if (this.fileinputAttachment.nativeElement.files[0] !== undefined && this.fileinputAttachment.nativeElement.files[0] !== null) {
        this.FileUpload.AddFileInQueueForUploading(this.fileinputAttachment);
        PostData.FileURLs = 'Uploads/' + this.fileinputAttachment.nativeElement.files[0].name;
      }
    }

    PostData.Content = this.Default.SanitizerHTML(this.InputFields.Content);
    if (PostData.Content == '') {
      l_strMessage += '*Message'
      l_boolIsOkay = false;
    }
  
   
    if (l_boolIsOkay) {
      this.AjaxSaveMessage(PostData);
    }
    else {
      this.Default.ShowAlert(l_strMessage);
    }

  }


  public AjaxSaveMessage(PostData) {

    this.Default.SetMasterAnimation(true);

    this.http.post(this.baseUrl + 'api/Message/AjaxSaveMessage', PostData).subscribe(result => {
      var l_arrResponse = result as any;
      this.Default.SetMasterAnimation(false);
      if (l_arrResponse[0][0].Status == 1) {
        this.InputFields.Content = '';
      
        this.Message = l_arrResponse[1];
        this.Attachment = l_arrResponse[2];
      }
      else {

      }
    }, error => console.error(error));
  }

  public ShowListToSelectUsers() {
    if ((this.InputFields.Content).lastIndexOf('@') > -1) {
      var l_strArray: any[] = (this.InputFields.Content).split('@');
      var l_strLastWord = (l_strArray[l_strArray.length - 1]).toLowerCase();
      if (l_strLastWord.indexOf(' ') < 0 && l_strLastWord) {
        this.UserArrayTagged = [];
        for (var i = 0; i < this.UserArrayFromDb.length ; i++) {
          if ((this.UserArrayFromDb[i].Name).toLowerCase().includes(l_strLastWord)) {
            if ( this.UserArrayTagged.length < 10) {
              this.UserArrayTagged.push(this.UserArrayFromDb[i]);
            }
          }
        }
      }
      else {
        this.UserArrayTagged = [];
      }
    }
  }
  public GetUserNameEmailAndID() {
    this.http.get(this.baseUrl + 'api/SiteUser/GetUserNameEmailAndID').subscribe(result => {

      this.UserArrayFromDb = result as any;

    }, error => console.error(error));
  }

  public SlectUser(p_strUserEmail: string) {
    for (var i = 0; i < this.UserArrayTagged.length; i++) {
      if (this.UserArrayTagged[i].Email == p_strUserEmail) {
        var l_strFirstPart = (this.InputFields.Content).substring(0, (this.InputFields.Content).lastIndexOf("@"));
        var l_strWordToAdd = this.UserArrayTagged[i].LoginName;
        this.InputFields.Content = l_strFirstPart + l_strWordToAdd;
        this.UserArrayTagged = [];
        (<HTMLInputElement>document.getElementById('textAreaMessage')).focus();
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/Communication/Messaging.ts